import { combineReducers } from "@reduxjs/toolkit";
import planningCenterTools from "./planning-center-tools";

const planningCenterToolsReducer = combineReducers({
  planningCenterTools,
});

export default planningCenterToolsReducer;
